import { render, staticRenderFns } from "./Tags_vendors.vue?vue&type=template&id=fcc3e8f0&scoped=true&"
import script from "./Tags_vendors.vue?vue&type=script&lang=js&"
export * from "./Tags_vendors.vue?vue&type=script&lang=js&"
import style0 from "./Tags_vendors.vue?vue&type=style&index=0&id=fcc3e8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc3e8f0",
  null
  
)

export default component.exports